import React, { useState, useEffect, useRef } from "react";
import { usePsChat } from "../../../context/PsChatMessageContext";

const ReportThreadAlert = ({
  isOpen,
  onClose,
  threadId,
  userId
}) => {
  const { reportThread } = usePsChat();
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    if (isOpen) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isOpen, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!reason.trim()) {
      setError("A reason is required.");
      return;
    }

    setSaving(true);
    try {
      await reportThread(
        threadId,
        reason,
        details || null,
        userId
      );
      onClose?.();
    } catch (err) {
      console.error("[ReportThreadAlert] Error:", err);
      setError("Something went wrong. Try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="alert-overlay" />

      <div
        className="alert-window"
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Report User</h2>

        <p>
          This will flag the conversation for admin review.
        </p>

        <form onSubmit={handleSubmit}>
          <label>Reason *</label>
          <input
            type="text"
            className="report-input"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Harassment, fraud attempt, abuse..."
            disabled={saving}
            required
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              marginBottom: "6px",
            }}
          />

          <label>Details (optional)</label>
          <textarea
            className="report-textarea"
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            placeholder="Add more context (optional)..."
            disabled={saving}
            style={{
              width: "100%",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              padding: "8px 10px",
              minHeight: "80px",
            }}
          />

          {error && (
            <div
              style={{
                color: "#dc2626",
                fontSize: "0.85rem",
                marginTop: "6px",
              }}
            >
              {error}
            </div>
          )}

          <div className="alert-actions" style={{ marginTop: "16px" }}>
            <button onClick={handleCancel} disabled={saving}>
              Cancel
            </button>

            <button
              type="submit"
              className="btn-danger"
              disabled={saving}
            >
              {saving ? "Submitting..." : "Submit Report"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ReportThreadAlert;
